// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	type Store as StoreType,
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	createStateHook,
	type HookStateFunction,
} from '@atlassian/react-sweet-state';

import { asyncValues } from '@jira/polaris__lib-ts-utils/src/async-value.tsx';
import type { State, Actions, LoadProps } from './PolarisEntitlementStore.types.tsx';
import { loadEditionMeta } from './loadEditionMeta.tsx';

const initialState: State = {
	editionMeta: asyncValues.idle(),
};

const actions: Actions = {
	loadEditionMeta,
};

export const PolarisEntitlementStore: StoreType<State, Actions, unknown> = createStore({
	initialState,
	actions,
	name: 'PolarisEntitlementStore',
});

const useEntitlementStoreActions: HookActionsFunction<BoundActions<State, Actions>> =
	createActionsHook(PolarisEntitlementStore);

export const useLoadEditionMeta = (): ((props: LoadProps) => Promise<void>) => {
	const storeActions = useEntitlementStoreActions();
	return storeActions.loadEditionMeta;
};

export const useIsEditionMetaLoading: HookStateFunction<boolean, void> = createStateHook(
	PolarisEntitlementStore,
	{
		selector: (state) =>
			state.editionMeta.status === 'idle' || state.editionMeta.status === 'loading',
	},
);

export const useIsEnterpriseEdition: HookStateFunction<boolean, void> = createStateHook(
	PolarisEntitlementStore,
	{
		selector: (state) =>
			state.editionMeta.status === 'loaded' && state.editionMeta.value === 'enterprise',
	},
);
